var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('ProgressBar',{attrs:{"step":2}}),_c('br'),_c('VinData')],1),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }